// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-date-range-index-container","label":"antd-pro-components-date-range-index-label"};